export default "__VITE_ASSET__LbCi6wwq__"